import { useRef } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { SourceUploadDialogPage } from 'types/kinerja'

import type { SourceUploadDialogPageBaseProps } from 'types/kinerja'

import ImgFolderFileDocumentDownload from 'assets/icons/img-folder-file-document-download.svg'
import ImgShareBuktiKarya from 'assets/icons/img-sharing-bukti-karya.svg'

interface SourceUploadDialogPage1Props
  extends SourceUploadDialogPageBaseProps<unknown> {
  onChange: (file: File) => void
  onClose?: Function
}

export default function Page1({
  onChange = () => {},
  onClose = () => {},
  onSetPage = () => {},
}: SourceUploadDialogPage1Props) {
  const fileUploadRef = useRef<HTMLInputElement>(null)

  const openFileUpload = () => {
    fileUploadRef.current?.click()
  }

  return (
    <div>
      <div>
        <Text variant="display-sm" className="mb-[6px]">
          Pilih cara unggah Bukti Dukung
        </Text>
        <Text variant="eyebrow-lg" color="subdued">
          Anda bisa unggah dokumen dari laptop/komputer atau
          <br />
          ambil dari Bukti Karya.
        </Text>
      </div>

      <div className="flex flex-col gap-6 mt-9">
        <div className="rounded border border-[#808489] p-6 flex items-center gap-4">
          <ImgFolderFileDocumentDownload width={84} height={84} />

          <div className="flex flex-col gap-1 flex-1">
            <Text>Unggah dari laptop/komputer*</Text>
            <Text variant="body-sm" color="subdued">
              Dokumen dengan{' '}
              <span className="font-bold">format PDF, maks. 10 MB.</span>
            </Text>
            <Text variant="body-sm" color="informational">
              *Otomatis akan terunggah di Draf Bukti Karya.
            </Text>
          </div>

          <div className="relative">
            <input
              type="file"
              ref={fileUploadRef}
              className="invisible absolute top-0"
              accept="application/pdf"
              data-testid="input-file-upload"
              onChange={(e) => {
                const file = e.target.files?.[0]
                if (file) {
                  onChange(file)

                  // close dialog
                  onClose()
                }
              }}
            />
            <Button onClick={openFileUpload}>Unggah dokumen</Button>
          </div>
        </div>

        <div className="rounded border border-[#808489] p-6 flex items-center gap-4">
          <ImgShareBuktiKarya width={84} height={84} />

          <div className="flex flex-col gap-1 flex-1">
            <Text>Ambil dari Bukti Karya</Text>
            <Text variant="body-sm" color="subdued">
              Karya Anda yang memiliki{' '}
              <span className="font-bold">format Dokumen (PDF)</span>.
            </Text>
          </div>

          <Button
            onClick={() =>
              onSetPage(SourceUploadDialogPage.BUKTI_KARYA_CATEGORIES)
            }
          >
            Ambil karya
          </Button>
        </div>
      </div>
    </div>
  )
}
